import { generatePath, useParams } from '@fs/zion-router'
import { useRouteMatch, type match } from 'react-router'
import { type PathParamMap } from '../types/pathParamTypes'
import { type TREE_SETTINGS_PATH } from '../routes'

export type TreeSettingsRouteParams = PathParamMap<typeof TREE_SETTINGS_PATH>

export type TabName = TreeSettingsRouteParams['tab']

export const getTabUrl = (tab: TabName, match: match<TreeSettingsRouteParams>): string =>
  generatePath(match.path, { ...match.params, tab })

export const useTreeSettingsParams = (): TreeSettingsRouteParams => {
  return useParams()
}

export const useTreeSettingsRouteMatch = (): match<TreeSettingsRouteParams> => {
  return useRouteMatch()
}
